import _extends from "@babel/runtime/helpers/extends";
import { ClassNames } from "@emotion/core";
import React, { forwardRef } from "react";
import { FOCUS_USING_BEFORE_CLASS_NAME } from "./focusRing";

/**
 * HOC that is useful for wrapping @emotion/styled components to provide them a className
 * and still allow other classNames to be applied.
 * This specifically is used to apply the classNames used in focus toggling. {@see FocusToggleStyles} for more info.
 * @param focusTypeClassName Defaults to {@see FOCUS_USING_BEFORE_CLASS_NAME}, but can be
 *                           set to {@see FOCUS_USING_ELEMENT_CLASS_NAME} as well.
 */
export const withFocusToggleClassName = function (InnerComponent) {
  let focusTypeClassName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : FOCUS_USING_BEFORE_CLASS_NAME;
  const NewComponent = /*#__PURE__*/forwardRef((props, ref) => {
    return /*#__PURE__*/React.createElement(ClassNames, null, _ref => {
      let {
        cx
      } = _ref;
      return /*#__PURE__*/React.createElement(InnerComponent, _extends({}, props, {
        ref: ref,
        className: cx(focusTypeClassName, props.className)
      }), props.children);
    });
  });
  NewComponent.displayName = `${InnerComponent.displayName || InnerComponent.name || ""}WithFocusToggleClassName`;
  return NewComponent;
};
//# sourceMappingURL=withFocusClassName.js.map